import { WorkflowAutomation } from "@/components/WorkflowAutomation";

const AutomationPage = () => {
  return <WorkflowAutomation />;
};

export default AutomationPage;